import { render, staticRenderFns } from "./DistributionSpecificPercentages.vue?vue&type=template&id=e608ff68&scoped=true"
import script from "./DistributionSpecificPercentages.vue?vue&type=script&lang=js"
export * from "./DistributionSpecificPercentages.vue?vue&type=script&lang=js"
import style0 from "./DistributionSpecificPercentages.vue?vue&type=style&index=0&id=e608ff68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e608ff68",
  null
  
)

export default component.exports